export default "__VITE_ASSET__b1caee5c__"